// extracted by mini-css-extract-plugin
export default {"label":"date-range_label__RGwXG","labelShifted":"date-range_labelShifted__QIInP","item":"date-range_item__k76AH","rangePicker":"date-range_rangePicker__yxnEf"};